// talabnoma §8.2 (2026-09-06): barcha modal oynalar sarlavhasidan ushlab siljitiladi (react-draggable, antd modalRender).
// Statik metodlar (confirm/info/…) antd'nikiga o'tkaziladi — ular oddiy dialog bo'lib qoladi.
import { Modal as AntModal, ModalProps } from "antd"
import React from "react"

// tog'a #2026 (2026-09-14): sudrash endi GLOBAL (utils/globalModalDrag) — bu yerda faqat sarlavha klassi qoladi (kursor),
// react-draggable modalRender olib tashlandi: aks holda oyna ikki mexanizm bilan ikki marta siljirdi.
/**
 * tog'a #2231 (2026-09-21): tanlash oynasi («Закупка», «Товар», «Остатки» — Drawer `zIndex 1020`) ICHIDAN
 * ochilgan modal past qavatda qolib, o'sha oynaning ORQASIGA tushardi — foydalanuvchi uchun «tugma
 * ishlamayapti» (jonli dalil: /transfers → Добавить → Закупка → «Цена продажи»/«Фильтр»).
 * Qoida: qavat raqamini QAT'IY yozma — ochiq eng ustki drawer'dan baland ol. Aniq `zIndex` berilgan bo'lsa u ustun.
 */
export const modalZ = (): number => {
  if (typeof document === "undefined") return 1010
  let top = 0
  document.querySelectorAll(".ant-drawer-open").forEach((el) => {
    const z = Number(window.getComputedStyle(el as HTMLElement).zIndex)
    if (!Number.isNaN(z)) top = Math.max(top, z)
  })
  return Math.max(1010, top + 10)
}

const DraggableModalBase: React.FC<ModalProps> = ({ title, zIndex, visible, ...rest }) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const z = React.useMemo(() => (zIndex !== undefined ? zIndex : modalZ()), [zIndex, visible])
  return (
    <AntModal {...rest} visible={visible} zIndex={z} title={title !== undefined && title !== null ? <div className="draggable-modal-title">{title}</div> : title} />
  )
}

// statik dialoglar — sukut zIndex 1030: 1010 li modal ichidan ochilganda orqada qolmasin
const withZ = (fn: any) => (props: any) => fn({ zIndex: 1030, ...props })

type Statics = Pick<typeof AntModal, "confirm" | "info" | "success" | "error" | "warning" | "warn" | "destroyAll" | "useModal" | "config">
const DraggableModal = Object.assign(DraggableModalBase, {
  confirm: withZ(AntModal.confirm),
  info: withZ(AntModal.info),
  success: withZ(AntModal.success),
  error: withZ(AntModal.error),
  warning: withZ(AntModal.warning),
  warn: withZ(AntModal.warn),
  destroyAll: AntModal.destroyAll,
  useModal: AntModal.useModal,
  config: AntModal.config,
} as Statics)

export default DraggableModal
